export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-laptop-dd7968e63492a24c89625adaeed062e2.svg";